import { IconFilters16, IconSort16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { EEntityType } from '../../types/filters';

interface IDealTypeFilterIcons {
  entityType: EEntityType | null;
  openSort(): void;
  openFilters(): void;
}

export const DealTypeFilterIcons: React.FC<IDealTypeFilterIcons> = ({ entityType, openSort, openFilters }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>Избранное</div>
      <div className={styles['controls']}>
        <button onClick={openSort} className={styles['input-link']}>
          <IconSort16 color="primary_100" />
        </button>
        {entityType !== EEntityType.Newbuilding && (
          <button onClick={openFilters} className={styles['input-link']}>
            <IconFilters16 color="primary_100" />
          </button>
        )}
      </div>
    </div>
  );
};
